import { render, staticRenderFns } from "./TapSortingStatementItem.vue?vue&type=template&id=7ca2fd93&"
import script from "./TapSortingStatementItem.vue?vue&type=script&lang=ts&"
export * from "./TapSortingStatementItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports